import { render, staticRenderFns } from "./whiteVoice.vue?vue&type=template&id=2c817391&"
import script from "./whiteVoice.vue?vue&type=script&lang=js&"
export * from "./whiteVoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports